module.exports = __webpack_public_path__ + "img/facebook.a3ecb482.svg";